module.exports = __webpack_public_path__ + "img/ru.e0012980.svg";